import {tenant, tenantKey} from '@shared/utils/tenant';

export default function loadLocaleMessages () {
    const messages = {};
    

    // 비재귀 — tenants/ 하위까지 잡히면 messages[locale] 이 마지막 테넌트 파일로 덮여 전 테넌트가 오염된다
    const sharedLocales = require.context('@shared/locales', false, /[A-Za-z0-9-_,\s]+\.json$/i);
    sharedLocales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = sharedLocales(key);
        }
    });


    const locales = require.context('@/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = {
                ...messages[locale],
                ...locales(key)
            };
        }
    });

    // 3단째: 테넌트별 문구 오버라이드 (custom 레포의 앱 로컬 locale 얕은 스프레드를 흡수한 자리)
    const overrides = tenant && tenant.i18nOverrides;
    if (overrides) {
        Object.keys(overrides).forEach(locale => {
            messages[locale] = {
                ...messages[locale],
                ...overrides[locale]
            };
        });
    }

    return messages;
}

// 4단째: 테넌트별 로케일 파일 (packages/shared/locales/tenants/<key>/<locale>.json)
// — custom 앱 로컬 locale(앱별 얕은 스프레드)의 이관본. 보고서 en/ca 문구·테넌트별 등급 라벨·ko disclaimer 등.
// 부트 직후 비동기 병합(테넌트 파일만 별도 청크). 파일 없음 = 오버라이드 없음. qesg 는 파일 없음(공용 shared 가 곧 qesg).
export async function loadTenantLocaleMessages (i18n) {
    if (!tenantKey || tenantKey === 'qesg') return;
    // webpack 4 는 동적 import 템플릿 안의 harmony import 바인딩을 치환하지 않아 bare `tenantKey` 로 방출된다
    // (ReferenceError → catch 에 삼켜져 조용히 미적용). 로컬 변수를 경유해야 한다.
    const key = tenantKey;
    for (const locale of ['ko', 'en', 'ca']) {
        try {
            const mod = await import(/* webpackChunkName: "tenant-locale-[request]" */ `../locales/tenants/${key}/${locale}.json`);
            i18n.mergeLocaleMessage(locale, mod.default || mod);
        } catch (e) {
            // 해당 테넌트/로케일 파일 없음 — 정상
        }
    }
}
